import React, { Suspense } from 'react';
import { Box, Container } from '@mui/material';
import Navbar from '../components/Navbar.js';
const Aurora = React.lazy(() => import('../components/AuroraBackground.js'));

const gradients = [
  'linear-gradient(135deg, rgba(96, 165, 250, 0.14) 0%, rgba(14, 116, 144, 0.08) 100%)',
  'linear-gradient(135deg, rgba(248, 113, 113, 0.16) 0%, rgba(244, 114, 182, 0.08) 100%)',
  'linear-gradient(135deg, rgba(129, 140, 248, 0.14) 0%, rgba(147, 197, 253, 0.08) 100%)',
];

const Main = ({ sections }) => {
  return (
    <>
      <Navbar sections={sections} />
      <Box component="main">
        {sections.map(({ id, component: SectionComponent }, index) => {
          const isAbout = id === 'about-me';

          return (
            <Box
              component="section"
              id={id}
              key={id}
              sx={{
                position: 'relative',
                py: { xs: 10, md: 14 },
                px: { xs: 2, sm: 4 },
                scrollMarginTop: { xs: 96, md: 120 },
                minHeight: 'auto',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  borderRadius: { xs: '34px', md: '42px' },
                  zIndex: 0,
                  background: gradients[index % gradients.length],
                  border: '1px solid rgba(148, 163, 184, 0.05)',
                  opacity: 0.32,
                },
              }}
            >
              {isAbout && (
                <Suspense fallback={null}>
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: { xs: 12, md: 18 },
                      borderRadius: { xs: '28px', md: '36px' },
                      overflow: 'hidden',
                      zIndex: 0,
                    }}
                  >
                    <Aurora height="165%" />
                    <Box
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        background:
                          'linear-gradient(185deg, rgba(4, 9, 20, 0.18) 0%, rgba(4, 9, 20, 0.48) 65%, rgba(4, 9, 20, 0.68) 100%)',
                      }}
                    />
                  </Box>
                </Suspense>
              )}

              <Container
                maxWidth="lg"
                sx={{
                  position: 'relative',
                  zIndex: 1,
                  px: { xs: 2, sm: 4, md: 6 },
                  py: { xs: 6, md: 8 },
                  borderRadius: { xs: '32px', md: '38px' },
                  overflow: 'hidden',
                  isolation: 'isolate',
                  ...(isAbout
                    ? {
                        background: 'transparent',
                        boxShadow: 'none',
                        border: '1px solid rgba(148, 163, 184, 0.1)',
                        backdropFilter: 'none',
                      }
                    : {
                        backdropFilter: 'blur(16px)',
                        background:
                          'linear-gradient(150deg, rgba(7, 12, 28, 0.86) 0%, rgba(3, 10, 26, 0.76) 45%, rgba(10, 24, 52, 0.7) 100%)',
                        boxShadow: '0 26px 60px rgba(4, 10, 26, 0.42)',
                        border: '1px solid rgba(148, 163, 184, 0.09)',
                      }),
                }}
              >
                <SectionComponent />
              </Container>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default Main;
